import { Charts } from '.';
function DataDistribution() {
    return (
        <div className="data-distribution"
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}
        >
          <Charts />
        </div>
    );
  }

export default DataDistribution; 